export enum EventType {
	DECISION_MAKING_SERVICE_READY = 'DecisionMakingServiceReady',
	DECISION_MAKING_SERVICE_VIEW_CHANGED = 'DecisionMakingServiceViewChanged',
}
